import './index.css'

import React from 'react'
import {render} from 'react-dom'

import Rewards from './Rewards'
import Admin from './Admin'
import Privacy from './Privacy'
import Terms from './Terms'



if(window.location.href.includes("admin")) {
  document.title = "Admin Portal - Petals Laser Lounge"
  render(<Admin/>, document.querySelector('#app'))
} else if(window.location.href.includes("privacy")) {
  render(<Privacy/>, document.querySelector('#app'))
} else if(window.location.href.includes("terms")) {
  render(<Terms/>, document.querySelector('#app'))
} else {
  render(<Rewards/>, document.querySelector('#app'))
}



// WEBPACK FOOTER //
// ./src/index.js